import { render, staticRenderFns } from "./CourseUpload.vue?vue&type=template&id=06c63c8c&"
import script from "./CourseUpload.vue?vue&type=script&lang=ts&"
export * from "./CourseUpload.vue?vue&type=script&lang=ts&"
import style0 from "./CourseUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports